export default __webpack_public_path__ + "static/media/losesscreen.af969d0f.png";